module.exports = __webpack_public_path__ + "img/202410_01_sp.37621b5f.jpg";